import {createFileRoute} from '@tanstack/react-router';

import {CreateTagForm} from '@/features/Library/components/Tag/CreateTagForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/tags/create')({
  component: CreateTagForm,
  beforeLoad: () => makeDocumentTitle('Create Tag'),
});
